'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { object } = propTypes;

const DirectionRoute = props => (
  <div className="mapRoute">
    <table className="table table-condensed table-hover">
      <thead>
        <tr>
          <td>Starting: <strong>{ props.directions.start_address }</strong></td>
          <td width="100"><small>{ props.directions.distance.text }<br />{ props.directions.duration.text }</small></td>
        </tr>
      </thead>
      <tbody>
        { props.directions.steps.map( step => {
          return (
            <tr>
              <td dangerouslySetInnerHTML={{ __html: step.instructions }} />
              <td><small>{ step.distance.text }<br />{ step.duration.text }</small></td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan="2">Ending: <strong>{ props.directions.end_address }</strong></td>
        </tr>
      </tfoot>
    </table>
  </div>
);

DirectionRoute.propTypes = {
  directions: object
};

module.exports = DirectionRoute;




// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/map/directionRoute.jsx